<ng-container *ngIf="!workflow">
	<nz-page-header [nzTitle]="'My ' + ticketMode + 's'" nzSubtitle="Choose workflow"></nz-page-header>

	<div class="workflow-grid">
		<nz-card *ngFor="let wf of workflows" [nzTitle]="wf.name" class="workflow-card c-title"
			(click)="selectWorkflow(wf)" nzHoverable>
			<p class="description">{{ wf.description }}</p>
			<button nz-button nzType="primary" class="select-btn">Select</button>
		</nz-card>
	</div>

</ng-container>

<ng-container *ngIf="workflow">
	<div class="workflow-heading text-center">
		<h2 class="m-0">{{ workflow.label }}</h2>
	</div>

	<nz-steps nzDirection="horizontal" nzLabelPlacement="vertical" [nzCurrent]="currentStepIndex"
		(nzIndexChange)="onStepIndexChange($event)" class="pointer-steps step-wrap mb-3">
		<nz-step *ngFor="let step of workflow.steps; let i = index" [nzTitle]="title">
			<ng-template #title>{{step.label}} ({{step.ticketCount}})</ng-template>
		</nz-step>
	</nz-steps>


	<div class="row">
		<div class="col">
			<nz-page-header [nzTitle]="step!.label"></nz-page-header>
		</div>
		<ng-container *ngIf="agents">
			<div class="col-3" *hasPermission="['TicketAdmin']"><!-- ,'TicketViewOtherAgentsTickets' -->
				<nz-select *hasPermission="['TicketAdmin']" class="float-end" style="width: 300px"
					nzShowSearch nzPlaceHolder="Search agent" [ngModel]="selectedAgent"
					[nzFilterOption]="filterOption"
					(ngModelChange)="onSelect($event,includeOtherAgentsTickets)">
					<nz-option [nzValue]="undefined" [nzLabel]="'All Users'"></nz-option>
					<nz-option [nzValue]="getAuthedAgent()"
						[nzLabel]="'My ' + ticketMode + 's'"></nz-option>
					<nz-option nzDisabled="true" nzLabel="──────────"></nz-option>
					<nz-option *ngFor="let agent of agents"
						[nzLabel]="agent.firstName + ' ' + agent.lastName"
						[nzValue]="agent"></nz-option>
				</nz-select>
				<!-- <nz-select *hasPermission="['TicketViewOtherAgentsTickets']" class="float-end" style="width: 300px" nzShowSearch nzPlaceHolder="Include Other Agents Tickets" [ngModel]="includeOtherAgentsTickets" (ngModelChange)="onSelect(this.selectedAgent,$event)" >
					<nz-option [nzValue]="true" [nzLabel]="'All Tickets'"></nz-option>
					<nz-option [nzValue]="false" [nzLabel]="'Only unassigned or assigned to me'"></nz-option>
				</nz-select> -->
			</div>
		</ng-container>
	</div>

	<nz-table #ticketsTable [nzBordered]="true" [nzLoading]="loading" [nzData]="tickets" [nzFrontPagination]="false"
		[nzTotal]="total" [nzPageSize]="pageSize" [nzPageIndex]="pageIndex" [nzShowSizeChanger]="true"
		[nzPageSizeOptions]="[5, 10, 15, 20, 25, 50, 100]"
		(nzQueryParams)="onQueryParamsChange($event, getThis())">
		<thead>
			<tr>
				<th>Ref</th>
				<th>FAO</th>
				<th *ngIf="isShowTicketReferenceColumn">Ticket Reference</th>
				<th>Member Details</th>
				<th *ngIf="isShowMembershipColumn">Membership Number</th>
				<th>Category</th>
				<th>Status</th>
				<th>Action</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let ticket of tickets; let i = index" class="cursor-pointer"
				(dblclick)="openTicket(ticket)">
				<td>{{ ticket.ticketReference }}</td>
				<td>{{ ticket.assignedToAgent?.firstName }} {{ ticket.assignedToAgent?.lastName }}</td>
				<td *ngIf="isShowTicketReferenceColumn">{{ ticket.id }}</td>
				<td>{{ ticket.member.name }} {{ ticket.member.surname }}</td>
				<td *ngIf="isShowMembershipColumn">{{ ticket.membership?.membershipNumber??'-' }}</td>
				<td>{{ ticket.focusCategory || '-' }}</td>

				<td class="p-0">
					<nz-alert [nzBanner]="true" [nzType]="getSlaClass(ticket)"
						[nzDescription]="slaDescription" nz-tooltip
						[nzTooltipTitle]="slaTooltip" nzTooltipColor="white"
						nzTooltipOverlayClassName="sla-tooltip-overlay"
						nzTooltipPlacement="right">
						<ng-template #slaDescription>
							{{ticket.currentStepAndStateLabel}}
							<ul class="small">
								<li *ngIf="ticket.slaLevelOverall == 'Good'"
									class="text-success">
									{{ticket.timeUntilNextSlaLevelOverall}}</li>
								<li *ngIf="ticket.slaLevelOverall == 'Warning'"
									class="text-warning">
									{{ticket.timeUntilNextSlaLevelOverall}}</li>
								<li *ngIf="ticket.slaLevelOverall == 'Overdue'"
									class="text-danger">
									{{ticket.timeUntilNextSlaLevelOverall}}</li>
								<li *ngIf="ticket.slaLevelOverall == 'Critical'"
									class="text-danger">Overdue by:
									{{ticket.timeUntilNextSlaLevelOverall}}</li>
							</ul>
						</ng-template>
						<ng-template #slaTooltip>
							<div class="sla-tooltip">
								<!-- Ticket Level -->
								<div class="sla-tooltip-section">
									<div class="sla-tooltip-label">
										<span
											class="text-dark">{{ticketMode}}:</span>
										<span *ngIf="ticket.slaLevelGlobal && ticket.slaLevelGlobal != 'Critical'"
											class="sla-tooltip-time"
											[class]="getSlaTextClass(ticket.slaLevelGlobal)">
											{{ticket.timeUntilNextSlaLevelGlobal}}
										</span>
										<span *ngIf="ticket.slaLevelGlobal && ticket.slaLevelGlobal == 'Critical'"
											class="sla-tooltip-time"
											[class]="getSlaTextClass(ticket.slaLevelGlobal)">
											Overdue by:
											{{ticket.timeUntilNextSlaLevelGlobal}}
										</span>
									</div>
								</div>
								<!-- Status Level -->
								<div class="sla-tooltip-section">
									<div class="sla-tooltip-label">
										<span class="text-dark">Current
											Status:</span>
										<span *ngIf="ticket.slaLevelStatus && ticket.slaLevelStatus != 'Critical'"
											class="sla-tooltip-time"
											[class]="getSlaTextClass(ticket.slaLevelStatus)">
											{{ticket.timeUntilNextSlaLevelStatus}}
										</span>
										<span *ngIf="ticket.slaLevelStatus && ticket.slaLevelStatus == 'Critical'"
											class="sla-tooltip-time"
											[class]="getSlaTextClass(ticket.slaLevelStatus)">
											Overdue by:
											{{ticket.timeUntilNextSlaLevelStatus}}
										</span>
									</div>
								</div>
								<!-- Step Level -->
								<div class="sla-tooltip-section">
									<div class="sla-tooltip-label">
										<span class="text-dark">Current
											Step:</span>
										<span *ngIf="ticket.slaLevelStep && ticket.slaLevelStep != 'Critical'"
											class="sla-tooltip-time"
											[class]="getSlaTextClass(ticket.slaLevelStep)">
											{{ticket.timeUntilNextSlaLevelStep}}
										</span>
										<span *ngIf="ticket.slaLevelStep && ticket.slaLevelStep == 'Critical'"
											class="sla-tooltip-time"
											[class]="getSlaTextClass(ticket.slaLevelStep)">
											Overdue by:
											{{ticket.timeUntilNextSlaLevelStep}}
										</span>
									</div>
								</div>
								<!-- Overall Level -->
								<div class="sla-tooltip-section mt-2">
									<div class="sla-tooltip-label">
										<span class="text-dark">Overall:</span>
										<span *ngIf="ticket.slaLevelOverall && ticket.slaLevelOverall != 'Critical'"
											class="sla-tooltip-time"
											[class]="getSlaTextClass(ticket.slaLevelOverall)">
											{{ticket.timeUntilNextSlaLevelOverall}}
										</span>
										<span *ngIf="ticket.slaLevelOverall && ticket.slaLevelOverall == 'Critical'"
											class="sla-tooltip-time"
											[class]="getSlaTextClass(ticket.slaLevelOverall)">
											Overdue by:
											{{ticket.timeUntilNextSlaLevelOverall}}
										</span>
									</div>
								</div>
							</div>
						</ng-template>
					</nz-alert>
				</td>


				<td *hasPermission="['TicketAdmin','TicketAssigner']">
					<button nz-button *ngIf="!ticket.assignedToAgent"
						(click)="showAssignTicketToAgentPopup(ticket)">Assign</button>
					<button nz-button *ngIf="ticket.assignedToAgent"
						(click)="showAssignTicketToAgentPopup(ticket)">Reassign</button>
				</td>
				<td *withoutPermission="['TicketAdmin','TicketAssigner']">
					<ng-container *ngIf="!ticket.assignedToAgent">
						<button nz-button (click)="assignTicketToThisAgent(ticket)">Assign To
							Me</button>
					</ng-container>
					&nbsp;
				</td>
			</tr>
		</tbody>
	</nz-table>
</ng-container>